import React, { useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';
import LinesPerProduct from './LinesPerProduct';
import Header from './Header';
import DividerHorizontal from '../BuildingBlocks/Misc/DividerHorizontal';
import Grid from '../BuildingBlocks/Timeline/Grid';

const useStyles = makeStyles((theme: any) => ({
  linesWrapper: {
    display: 'contents',
    marginBottom: theme.spacing(3),
    '& .MuiTableContainer-root': { overflowX: 'unset' },
  },
  stickyHeaders: {
    zIndex: theme.zIndex.pageContent + 2,
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.brand.white,
  },
}));

export default function LayoutTimeline({
  linesGroupedByProduct,
  numOfLinesToShow = 0,
  handleLineSubmit,
  addOrDeleteError,
  filterPlan,
  setFilterPlan,
}) {
  const classes = useStyles();
  const headerReference = useRef(undefined);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const applicationId = params.get('plan');
    if (applicationId) {
      setFilterPlan(applicationId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div ref={headerReference} className={classes.stickyHeaders}>
        <Header filterPlan={filterPlan} setFilterPlan={setFilterPlan} />
        <DividerHorizontal />
      </div>
      <Grid numOfLinesToShow={numOfLinesToShow}>
        <div className={classes.linesWrapper}>
          {linesGroupedByProduct.map((linesForProduct, i) => {
            return (
              <LinesPerProduct
                key={i}
                lines={linesForProduct}
                handleLineSubmit={handleLineSubmit}
                addOrDeleteError={addOrDeleteError}
                firstProduct={i === 0}
              />
            );
          })}
        </div>
      </Grid>
    </>
  );
}
